import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiService from "../../api/ApiService";
import { paginateCount } from "../../api/helper";
import { useDispatch, useSelector } from "react-redux";
import {addTohistories} from '../../redux/slices/adminSlice'
const moment=require('moment-jalaali')



 const useHistoryCycle=({flag})=>{
  const dispatch=useDispatch()
  const {currentAdmin,data}=useSelector(state=>state.p.admin)
    const navigate=useNavigate()
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null
  });
  const [total,setTotal]=useState(1)
  const [page,setPage]=useState(0)
    const [SData,setSdata]=useState({})
    const [importanceLevel,setImportancelevel]=useState(null)
    const [importanceList,setImportanceList]=useState([])
  const {id}=useParams()
  const [value, setValue] = useState('0');
  const getImportanceList=async()=>{
    const res=await apiService.getImportanceLevelList()
    setImportanceList(res.data.data)
}
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const getData=async()=>{
    let geregorian1=moment(`${selectedDayRange.from?.year}-${selectedDayRange.from?.month}-${selectedDayRange.from?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')


    let geregorian2=moment(`${selectedDayRange.to?.year}-${selectedDayRange.to?.month}-${selectedDayRange.to?.day}T00:00:00`,'jYYYY-jMM-jDD h:mm:dd')
    
      const data=JSON.stringify({
        "skip": page?(page-1)*paginateCount:0,
        "take": paginateCount,
        "fromDate": selectedDayRange.from?geregorian1:null,
        "toDate": selectedDayRange.to?geregorian2:null,
        "cattleIds": flag==='all'?[]:[
            id
          ],
          "farmId":currentAdmin?.id,

        "entryUserId": null,
        "isReaded": value==1?true:false,
        "importanceLevel":importanceLevel==null?null:+importanceLevel
      })
      const res=await apiService.getCattleHistoryCycle(data)
      dispatch(addTohistories(res.data.data))
      setTotal(Math.ceil(res.data.totalCount/paginateCount))
  }
  const handlePage = (event, value) => {
    setPage(value);
  };

  useEffect(()=>{
    if(selectedDayRange.to!==null){
      if(page===0){
        getData()
      }
      setPage(0)
    }
  },[selectedDayRange.to])
  useEffect(()=>{
    
    if(importanceLevel!==null){
      if(page===0){
        getData()
      }
      setPage(0)
    }
    
  },[importanceLevel])
  // useEffect(()=>{getImportanceList()},[])
  useEffect(()=>{
    getData()
  },[page,value])
  return {selectedDayRange, setSelectedDayRange,data,navigate,page,handlePage,total,handleChange,value,SData,setSdata,setImportancelevel,importanceLevel,importanceList}
}
export default useHistoryCycle